var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgDelete = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.2 7.33398H9V13.734H8.2V7.33398ZM9.8 7.33398H10.6V13.734H9.8V7.33398ZM11.4 7.33398H12.2V13.734H11.4V7.33398ZM5 4.93398H15.4V5.73398H5V4.93398ZM12.2 4.93398H11.4V4.53398C11.4 4.29398 11.24 4.13398 11 4.13398H9.4C9.16 4.13398 9 4.29398 9 4.53398V4.93398H8.2V4.53398C8.2 3.85398 8.72 3.33398 9.4 3.33398H11C11.68 3.33398 12.2 3.85398 12.2 4.53398V4.93398Z",
    fill: "#31373D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6008 16.1349H7.80078C7.16078 16.1349 6.60078 15.6149 6.52078 14.9749L5.80078 5.37492L6.60078 5.29492L7.32078 14.8949C7.32078 15.1349 7.56078 15.3349 7.80078 15.3349H12.6008C12.8408 15.3349 13.0408 15.1349 13.0808 14.8949L13.8008 5.29492L14.6008 5.37492L13.8808 14.9749C13.8008 15.6149 13.2408 16.1349 12.6008 16.1349Z",
    fill: "#31373D"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDelete, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/delete.4a8d5821.svg";
export { ForwardRef as ReactComponent };